import React from 'react';
import { motion } from 'framer-motion';
import { ThermometerIcon, ZapIcon, ListChecksIcon } from 'lucide-react';
import { FeatureCard } from './FeatureCard';
import { CTAButton } from './CTAButton';
import { trackAddToCart } from '../utils/metaPixel';
export function SolutionSection() {
  return <section className="py-24 px-4 bg-[#0a0e1a] relative" data-id="element-90">
      <div className="max-w-3xl mx-auto" data-id="element-91">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="mb-16 text-center" data-id="element-92">
          <h2 className="font-heading text-3xl sm:text-4xl text-white mb-6" data-id="element-93">
            La Solución:{' '}
            <span className="text-amber-400" data-id="element-94">Protocolo Cortisol-Zero™</span>
          </h2>
          <p className="text-lg text-slate-300 leading-relaxed" data-id="element-95">
            He condensado la ciencia de la termorregulación y la cronobiología
            en un manual práctico que puedes leer en 15 minutos. No es un libro
            de teoría.{' '}
            <span className="text-white font-medium" data-id="element-96">
              Es un manual de instrucciones para tu sistema nervioso.
            </span>
          </p>
          <p className="mt-6 text-cyan-300 font-medium" data-id="element-97">
            Esto es lo que obtienes hoy por solo $6.36:
          </p>
        </motion.div>

        <div className="space-y-6 mb-16" data-id="element-98">
          <FeatureCard icon={<ThermometerIcon size={24} data-id="element-100" />} title="El Interruptor Térmico" description="El método exacto para bajar tu temperatura central 1.2°C y forzar a tu cerebro a entrar en sueño profundo." delay={0.1} data-id="element-99" />
          <FeatureCard icon={<ZapIcon size={24} data-id="element-102" />} title="La Purga de Adenosina" description="Cómo usar la cafeína a tu favor para que tu energía sea constante y no sufras el 'crash' de las 3 PM." delay={0.2} data-id="element-101" />
          <FeatureCard icon={<ListChecksIcon size={24} data-id="element-104" />} title="Checklist de Reseteo de 7 Minutos" description="Los 3 pasos mecánicos que debes hacer antes de tocar la almohada para silenciar el ruido mental." delay={0.3} data-id="element-103" />
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="flex justify-center" data-id="element-105">
          <CTAButton text="Obtener el Protocolo Ahora" onClick={() => {
          trackAddToCart();
          window.open('https://novadigitalventures.com/cart/42535353811015:1', '_blank');
        }} data-id="element-106" />
        </motion.div>
      </div>
    </section>;
}